import script from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailsView.vue?vue&type=style&index=0&id=06f3b346&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f3b346"]])

export default __exports__